import { ArrowBack, OpenInNew } from '@mui/icons-material'
import { Box, Button, Link, Stack, Typography } from '@mui/material'
import { StartTrainingAttendancePlanList } from './StartTrainingAttendancePlanList'
import { StartLeadershipDayAndConferenceList } from './StartLeadershipDayAndConferenceList'
import { StartCommunityOfPracticeList } from './StartCommunityOfPracticeList'

interface Props {
  priorityId: number
  annualPLanId: number
  rcnId: number
  readOnly: boolean
  trackingReadonly: boolean
  implementationPhase: boolean
  onBack: () => void
  handleViewContract?: () => void
}

export const STARTEventAttendancePlan = (props: Props): JSX.Element => {
  const upcomingTrainingLink = <Link sx={{ cursor: 'pointer' }} onClick={() => { window.open('https://www.gvsu.edu/autismcenter/start-trainings-49.htm', '_blank') }}>
    Upcoming START Trainings and Training Series
  </Link>
  return <Box data-testid='startEventAttendancePlan' sx={{
    display: 'flex',
    flexDirection: 'column',
    gap: '20px'
  }}
  >
    <Stack direction='row' justifyContent='space-between' alignItems='center'>
      <Button
        data-testid="backPdrsButton"
        onClick={props.onBack}
        sx={{
          padding: '5px 10px',
          backgroundColor: 'var(--grey-50)',
          color: 'var(--grey-500)',
          width: 'fit-content',
          textTransform: 'none'
        }}
      >
        <ArrowBack sx={{ mr: '10px' }} />
        Professional Learning
      </Button>

      {props.implementationPhase && (
        <Button
          data-testid="viewContractButton"
          sx={{
            padding: '5px 10px',
            backgroundColor: 'var(--grey-50)',
            color: 'var(--grey-500)',
            width: 'fit-content',
            textTransform: 'none'
          }}
          onClick={props.handleViewContract}
        >
          View Contract
          <OpenInNew fontSize='small' sx={{ ml: '10px' }} />
        </Button>
      )}
    </Stack>

    <Typography variant='h1'>START Event Attendance Plan</Typography>
    <Typography variant='body1'>
      List the START trainings and events that will be attended by RCN members, ISD/District staff, and families in the tables below. Indicate how many individuals you anticipate will attend each training or event and the budget request. Please note that this is not a registration system. To register for START events, please visit the {upcomingTrainingLink} webpage.
    </Typography>

    <StartTrainingAttendancePlanList priorityId={props.priorityId} annualPlanId={props.annualPLanId} rcnId={props.rcnId} readOnly={props.readOnly} trackingReadonly={props.trackingReadonly} implementationPhase={props.implementationPhase} />

    <StartLeadershipDayAndConferenceList priorityId={props.priorityId} readOnly={props.readOnly} trackingReadonly={props.trackingReadonly} implementationPhase={props.implementationPhase} />

    <StartCommunityOfPracticeList priorityId={props.priorityId} readOnly={props.readOnly} trackingReadonly={props.trackingReadonly} implementationPhase={props.implementationPhase} />
  </Box>
}
